import { ComponentProps } from 'react';
import InputDatePickerV2 from '@bridebook/ui/src/components/bbcommon/inputs/input-datepicker-v2/input-datepicker-v2';
import { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import { colors } from '../../../../themes/variables';

interface IStyle {
  input: FelaCSS;
  icon: FelaCSS;
}

const styles = (variant: ComponentProps<typeof InputDatePickerV2>['variant']): IStyle => ({
  input: {
    pointerEvents: 'none',
    ...(variant !== 'borderless' && {
      height: 54,
      overflow: 'hidden',
    }),
  },
  icon: {
    backgroundColor: colors.indigoCrush,
    padding: 5,
  },
});

export default styles;
